import Ajv from 'ajv';
import Ajv2019 from 'ajv/dist/2019';
import Ajv2020 from 'ajv/dist/2020';

const getAjv = (mode, strict) => {
  let ajv;

  if (mode == '2019') {
    ajv = new Ajv2019({ strict });
  }
  else if (mode == '2020') {
    ajv = new Ajv2020({ strict });
  }
  else {
    ajv = new Ajv({ strict });
  }

  return ajv;
};

export default getAjv;